import React from 'react';
import { useSwipeable } from 'react-swipeable';
import {AnimatePresence, motion} from 'framer-motion';

import UniversityCardExplore from '../UniversityCardExplore';
import UniversityReview from '../../client/partials/university/UniversityReview';
import ExploreModel from '../../../networking/models/ExploreModel';
import Review from '../../../networking/models/Review';
import Map from '../../client/layout/Map'

interface Props {
    universities: ExploreModel[];
    currentIndex: number;
    direction: number;
    next: () => void;
    previous: () => void;
}

const UniversitySlider: React.FC<Props> = ({universities, currentIndex, next, previous, direction}) => {

    const currentUniversity = universities[currentIndex];

    const handlers = useSwipeable({
        onSwipedLeft: () => {
            if(currentIndex !== universities.length - 1) {
                next();
            }
        },
        onSwipedRight: () => {
            if(currentIndex !== 0) {
                previous();
            }
        },
        // preventDefaultTouchmoveEvent: true, // TODO: Fix this
        trackMouse: true
    });

    const offset = 300;
    const variants = {
        enter: (direction: number) => ({
            x: direction > 0 ? offset : -offset,
            opacity: 0,
        }),
        active: {
            x: 0,
            opacity: 1,
            transition: { duration: 0.1 }
        },
        exit: (direction: number) => ({
            x: direction > 0 ? -offset : offset,
            opacity: 0,
            transition: { duration: 0.1 }
        })
    };

    return (
        <div className="university-slider" {...handlers}>
            <AnimatePresence mode={'wait'}>
                <motion.div
                    className={'university-slider__university'}
                    key={currentIndex}
                    variants={variants}
                    initial={'enter'}
                    animate={'active'}
                    exit={'exit'}
                    custom={direction}>

                    <UniversityCardExplore university={currentUniversity} explore={true} />

                    <h1 className="university-slider__title">Concluding</h1>
                    {/* <div className="university-slider__ratings">
                        {currentUniversity.form_parts[0].active_questions.map((review) => {
                            const reviewFormat: Review = {
                                description: review.name,
                                stars: (+ review.answers[0].value)
                            }

                            return (
                                <UniversityReview review={reviewFormat} key={review.id}/>
                            )}
                        )}
                    </div> */}

                    <h1 className="university-slider__title">Map</h1>
                    <Map
                        latitude={universities[currentIndex].latitude ?? 51.9851034}
                        longitude={universities[currentIndex].longitude ?? 5.8987296} />
                </motion.div>
            </AnimatePresence>
        </div>
    )
}

export default UniversitySlider;

